import { Box, Typography } from "@mui/material";

import BszSectionCard from "../BszSectionCard";
import { useBszFinderContext } from "../../../context/bszContext";
import { useAppContext } from "../../../../../2_ksbHub/context/appContext";

import { useTheme } from "@mui/material/styles";

import { useState } from "react";
import BszStudentRow from "./BszStudentRow";
import BszClassHeader from "./BszClassHeader";

export default function BszKlassenOverviewSection() {
  const theme = useTheme();

  const { classesOverview, serverNow, removeUserFromClass } =
    useBszFinderContext();

  const { isMobile } = useAppContext();

  const [open, setOpen] = useState({});

  /**
   * =========================================================
   * ✅ TOGGLE CLASS
   * =========================================================
   */
  const toggleClass = (id) => {
    setOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  /**
   * =========================================================
   * ✅ TIME HELPER
   * =========================================================
   */
  const getRemaining = (endTime) => {
    if (!endTime || !serverNow) return null;

    return Math.floor(Math.max(0, endTime - serverNow) / 60000);
  };

  /**
   * =========================================================
   * ✅ REMOVE HANDLER
   * =========================================================
   */
  const handleRemove = async (userId, classId) => {
    if (!window.confirm("Schüler wirklich entfernen?")) return;

    await removeUserFromClass(userId, classId);
  };

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <BszSectionCard
      title="Klassenübersicht"
      defaultExpanded={classesOverview.length <= 2}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {classesOverview.map((cls) => {
          const isOpen = !!open[cls.id];

          return (
            <Box key={cls.id}>
              {/* ✅ CLASS HEADER */}
              <BszClassHeader
                className={cls.name}
                studentCount={cls.students.length}
                isOpen={isOpen}
                onClick={() => toggleClass(cls.id)}
              />

              {/* ✅ STUDENTS */}
              {isOpen && (
                <Box sx={{ mt: 0.5 }}>
                  {cls.students
                    .sort((a, b) => a.lastName.localeCompare(b.lastName))
                    .map((s) => {
                      const remaining = getRemaining(s.endTime);

                      return (
                        <BszStudentRow
                          key={s.id}
                          student={s}
                          remaining={remaining}
                          isMobile={isMobile}
                          theme={theme}
                          onDelete={() => handleRemove(s.id, cls.id)}
                        />
                      );
                    })}
                </Box>
              )}
            </Box>
          );
        })}

        {/* ✅ EMPTY */}
        {classesOverview.length === 0 && (
          <Typography sx={{ opacity: 0.6 }}>
            Keine Klassen verfügbar oder keine Lernenden haben sich aktuell
            registriert
          </Typography>
        )}
      </Box>
    </BszSectionCard>
  );
}
